import { render, staticRenderFns } from "./gzpyzyjsxy.vue?vue&type=template&id=495ee30e&scoped=true&"
import script from "./gzpyzyjsxy.vue?vue&type=script&lang=js&"
export * from "./gzpyzyjsxy.vue?vue&type=script&lang=js&"
import style0 from "./gzpyzyjsxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./gzpyzyjsxy.vue?vue&type=style&index=1&id=495ee30e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495ee30e",
  null
  
)

export default component.exports